<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="渠道名字"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'name',
              { rules: [{ required: true, message: '请输入渠道名字' }] }
            ]"
            placeholder="请输入渠道名字"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="渠道代码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'code',
              { rules: [{ required: true, message: '请输入渠道代码' }] }
            ]"
            placeholder="请输入渠道代码"
          ></a-input>
        </a-form-item>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            v-decorator="[
              'status',
              { rules: [{ required: true, message: '请选择状态' }] }
            ]"
            placeholder="请选择状态"
          >
            <a-select-option :value="1" :key="1">
              正常
            </a-select-option>
            <a-select-option :value="0" :key="0">
              冻结
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="渠道类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'type',
              { rules: [{ required: true, message: '请选择渠道类型' }] }
            ]"
            placeholder="请选择渠道类型"
          >
            <a-select-option
              v-for="item in channelType"
              :key="item.value"
              :value="item.value"
              >{{ item.title }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          label="是否需要审核"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'needAudit',
              { rules: [{ required: true, message: '请选择是否需要审核' }] }
            ]"
            placeholder="请选择是否需要审核"
          >
            <a-select-option
              v-for="item in channelNeedAudit"
              :key="parseInt(item.value)"
              :value="parseInt(item.value)"
              >{{ item.title }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          label="关联微信账号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="['linkWechat', { rules: [] }]"
            placeholder="请选择关联微信账号"
          >
            <a-select-option
              v-for="item in wechatApp"
              :key="item.appId"
              :value="item.appId"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import { getAction } from '@/api/manage';
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';

export default {
  name: 'WechatAppModal',
  components: {
    JDate
  },
  data() {
    return {
      wechatApp: [],
      channelType: [],
      channelNeedAudit: [],
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_SYSTEM + '/sys/channel/add',
        edit: process.env.VUE_APP_CMS_SYSTEM + '/sys/channel/edit'
      }
    };
  },
  created() {
    this.getWechatApp();
    this.getChannelType();
    this.getChannelNeedAudit();
  },
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        if (record.type) {
          this.form.setFieldsValue({
            type: record.type + ''
          });
        }
        this.form.setFieldsValue(
          pick(this.model, 'name', 'code', 'status', 'needAudit', 'linkWechat')
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }
          let formData = Object.assign(this.model, values);
          console.log('表单提交数据', formData);
          httpAction(httpurl, formData, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(row, 'type', 'name', 'code', 'status', 'needAudit', 'linkWechat')
      );
    },
    getWechatApp() {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wechatApp/queryByType', {
        type: '1,2,3'
      }).then(res => {
        if (res.success) {
          this.wechatApp = res.result;
        }
      });
    },
    getChannelType() {
      getAction(
        process.env.VUE_APP_CMS_SYSTEM + `/sys/dict/getDictItems/channel_type`,
        {}
      ).then(res => {
        if (res.success) {
          this.channelType = res.result;
        }
      });
    },
    getChannelNeedAudit() {
      getAction(
        process.env.VUE_APP_CMS_SYSTEM +
          `/sys/dict/getDictItems/channel_need_audit`,
        {}
      ).then(res => {
        if (res.success) {
          this.channelNeedAudit = res.result;
        }
      });
    }
  }
};
</script>
